import { BlobEntityType } from "./enums/blobentitytype";

export class DocumentUploadInfo<T extends object> {
    public fileName: string;
    public data: T;
    public entityType: BlobEntityType;
    public entityId: number;
}
